module.exports = __webpack_public_path__ + "static/media/docker.0567bb27.svg";